export class ScoreManager {
  private score = 0;

  getScore() {
    return this.score;
  }

  reset() {
    this.score = 0;
  }

  add(amount: number) {
    this.score += amount;
  }

  subtract(amount: number) {
    if (amount < 0) return;
    this.score = Math.max(0, this.score - amount);
  }
}
